<template>
  <v-container>
    <v-layout>
      <edit-actions
        @change="changeDisplay"
        @save="save"
        @cancel="cancelEdit"
        :displayMode="isDisplayMode">
      </edit-actions>
    </v-layout>
    <v-layout v-for="(list, index) in updatedLists" :key="index">
      <items :data="list" ref="form" :displayMode="isDisplayMode">
        <v-btn color="accent" outline small icon @click="add"><v-icon small color="accent">add</v-icon></v-btn>
        <v-btn
          v-if="updatedLists.length > 1"
          color="darkGray"
          outline
          icon
          small
          @click="remove(index)">
          <v-icon small color="darkGray">remove</v-icon>
        </v-btn>
      </items>
    </v-layout>
  </v-container>
</template>
<script>
import Items from './Items'
import EditActions from '@/components/ui/EditActions'

export default {
  name: 'CostCenter',
  components: { Items, EditActions },
  data () {
    return {
      isValid: true,
      isDisplayMode: true,
      defaultList: [
        {
          name: 'Deivid',
          description: 'bla bla',
          templates: []
        }
      ],
      updatedLists: []
    }
  },
  methods: {
    add () {
      let data = {
        name: '', description: '', templates: []
      }
      this.updatedLists.push(data)
    },
    remove (index) {
      this.updatedLists.splice(index, 1)
    },
    changeDisplay (status) {
      this.isDisplayMode = status
    },
    save () {
      this.$refs.form.map((form) => {
        form.validation()
        this.isValid = form.validation()
      })
      this.isValid && this._success()
    },
    _success () {
      this.$root.$emit('snackbar', { show: true, color: 'success', text: 'Atualizado com sucesso' })
      this.isDisplayMode = true
    },
    cancelEdit () {
      this.setList()
    },
    setList () {
      this.updatedLists = Object.assign([], this.defaultList)
    }
  },
  mounted () {
    this.setList()
  }
}
</script>

